import { PostObject } from '../store/post/api/interface';

export const getterPost = (posts: PostObject[] = []) => {
    if (posts?.length === 0) return [];
    if (posts?.length <= 6) return posts;
    return posts.slice(0, 6);
};
